export const colors = {
  /* 👉 Rentify colors */
  primary: '#4629D3',
  secondary: '#020C3B',
  white: '#FFFFFF',
  green: '#22C55E',
  red: '#FF6868',
  grey: '#6B74A2',
  silver: '#F4F4F4',
  /* ... */
  muted: `#4d4d4d20`,
  transparent: `transparent`,
  midnightGreen: '#084c61ff',
  cedarChest: '#db504aff',
  orangeYellow: '#e3b505ff',
  cadet: '#4f6d7aff',
  cadetBlue: '#56a3a6ff',
  dodgerBlue: '#21a1fb',
  skyBlue: '#6592fe',
  royalBlue: '#5037f5',
  malibu: '#82c8f6',
  catskillWhite: '#eef6f7',
  darkMuted: '#343643',
  meadow: '#20b571',
  transparentMat: 'rgba(0, 0, 0, 0.2)',
};

export const transitions = {
  transitionShort: `all 0.4s ease-in-out`,
  transitionMedium: `all 0.8s ease-in-out`,
  transitionLong: `all 1.2s ease-in-out`,
};

export const fonts = {
  fontFamilies: `'Fira Mono', 'Andale Mono', 'Consolas', 'monospace'`,
  fontXXXSmall: `8px`,
  fontXXSmall: `10px`,
  fontXSmall: `12px`,
  fontSmall: `14px`,
  fontMedium: `16px`,
  fontXMedium: `20px`,
  fontLarge: `24px`,
  fontXLarge: `32px`,
  fontBannerSmall: `38px`,
  fontBannerMedium: `48px`,
  fontBannerLarge: `64px`,
  fontBannerXLarge: `72px`,
};

export const spacing = {
  spacingNone: `0px`,
  spacingXXSmall: `2px`,
  spacingXSmall: `4px`,
  spacingSmall: `8px`,
  spacingMedium: `12px`,
  spacingXMedium: `16px`,
  spacingLarge: `20px`,
  spacingXLarge: `24px`,
  spacingXXLarge: `32px`,
  spacingXXXLarge: `40px`,
  spacingXXXXLarge: `48px`,
  /* 👉 content width */
  contentMaxWidth: `800px`,
  navigationMaxWidth: `1100px`,
  /* 👉 break points */
  breakPointXSmall: `480px`,
  breakPointSmall: `576px`,
  breakPointMedium: `768px`,
  breakPointLarge: `992px`,
  breakPointXLarge: `1200px`,
  breakPointXXLarge: `1400px`,
  breakPointXXXLarge: `1600px`,
};

export const shadows = {
  boxShadow: `0 10px 20px rgb(0 0 0 / 20%)`,
  boxShadowLight: `0 2px 5px rgb(0 0 0 / 20%), 0 2px 10px rgb(0 0 0 / 10%),`,
  boxShadowMuted: `0 5px 40px -5px rgb(20 20 20 / 10%)`,
};
